import store from '../configureStore';
import { apiGet, apiPost } from './apiUtil';

export const addResource = (storagedResourceS3Key: string, parentId: string, name: string) => {
  const {
    project: { header },
    user: { identityId },
    workspace: { currentUserGroup },
  } = store.getState();
  const fileS3Path = `private/${identityId}/${storagedResourceS3Key}`;

  const espacedName = encodeURIComponent(name);

  const addResourceInit = {
    headers: header,
    body: `key=${fileS3Path}&parent=${parentId}&name=${espacedName}`,
  };
  return apiPost(`/resource/add?gid=${currentUserGroup}`, addResourceInit);
};

export const addResourceWithSnapshot = (
  storagedResourceS3Key: string,
  parentId: string,
  name: string,
  thumbnailAddingStorageResponseKey: string,
) => {
  const {
    project: { header },
    user: { identityId },
    workspace: { currentUserGroup },
  } = store.getState();
  const fileS3Path = `private/${identityId}/${storagedResourceS3Key}`;
  const thumbnailResourceS3Path = `private/${identityId}/${thumbnailAddingStorageResponseKey}`;

  const espacedName = encodeURIComponent(name);

  const addResourceInit = {
    headers: header,
    body: `key=${fileS3Path}&parent=${parentId}&name=${espacedName}&snapshot=${thumbnailResourceS3Path}`,
  };
  return apiPost(`/resource/add?gid=${currentUserGroup}`, addResourceInit);
};

export const updateResourceName = (resourceId: string, resourceName: string) => {
  const {
    project: { header },
    workspace: { currentUserGroup },
  } = store.getState();

  const espacedName = encodeURIComponent(resourceName);

  const updateResourceInit = {
    headers: header,
    body: `id=${resourceId}&name=${espacedName}`,
  };
  return apiPost(
    `/resource/update?gid=${currentUserGroup}`,
    updateResourceInit,
  );
};

export const updateResourceProjectPreviewStatus = (resourceId: string, resourceName: string, newPreviewStatus: boolean) => {
  const {
    project: { header },
    workspace: { currentUserGroup },
  } = store.getState();
  const updateResourceInit = {
    headers: header,
    body: `id=${resourceId}&name=${resourceName}&preview=${newPreviewStatus ? 1 : 0}`,
  };
  return apiPost(
    `/resource/update?gid=${currentUserGroup}`,
    updateResourceInit,
  );
};

export const updateResourceParent = (resourceId: string, resourceName: string, newParentId: string) => {
  const {
    project: { header },
    workspace: { currentUserGroup },
  } = store.getState();

  const espacedName = encodeURIComponent(resourceName);

  const updateResourceInit = {
    headers: header,
    body: `id=${resourceId}&name=${espacedName}&parent=${newParentId}`,
  };
  return apiPost(
    `/resource/update?gid=${currentUserGroup}`,
    updateResourceInit,
  );
};

export const getResourceDetails = (resourceId: string) => {
  const {
    project: { header },
    workspace: { currentUserGroup },
  } = store.getState();
  const getResourceDetailsInit = {
    headers: header,
  };
  return apiGet(
    `/resource/${resourceId}?gid=${currentUserGroup}`,
    getResourceDetailsInit,
  );
};

export const deleteResource = (resourceId: string) => {
  const {
    project: { header },
    workspace: { currentUserGroup },
  } = store.getState();
  const deleteResourceInit = {
    headers: header,
    body: `id=${resourceId}`,
  };
  return apiPost(
    `/resource/delete?gid=${currentUserGroup}&id=${resourceId}`,
    deleteResourceInit,
  );
};

export const copyResource = (resourceId: string, copyDestinationFolderParent: string) => {
  const {
    project: { header },
    workspace: { currentUserGroup },
  } = store.getState();
  const copyResourceInit = {
    headers: header,
    body: `id=${resourceId}&parent=${copyDestinationFolderParent}`,
  };
  return apiPost(
    `/resource/copy?gid=${currentUserGroup}`,
    copyResourceInit,
  );
};

export const convertFile = (resourceId: string) => {
  const {
    project: { header },
    workspace: { currentUserGroup },
  } = store.getState();
  const updateResourceInit = {
    headers: header,
  };
  return apiGet(
    `/convert/${resourceId}?gid=${currentUserGroup}`,
    updateResourceInit,
  );
};
